export function removeLastComma(strng) {
    const n = strng.lastIndexOf(',');
    const a = strng.substring(0, n);
    return a;
}
